import { Moment } from 'moment-timezone';

export const formatPhoneNumberForDisplay = (value: string): string => {
    if (!value) {
        return value;
    }

    const digits = value.replace(/[^\d]/g, '');

    if (digits.length === 10) {
        // 10-digit US number without country code
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    } else if (digits.length === 11 && digits.startsWith('1')) {
        // 11-digit US number with country code (1 + 10 digits)
        // Format: +1 (XXX)-XXX-XXXX
        return `+1 (${digits.slice(1, 4)})-${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
    } else {
        return value;
    }
};

export const formatPhoneNumberForBackend = (value: string): string => {
    // Remove non-numeric characters.
    return value.replace(/[^\d]/g, '');
};

export const formatInitial = (name: string): string => {
    return name.charAt(0).toUpperCase();
};

export const formatInitials = (firstName: string, lastName: string): string => {
    let initials: string;

    if (!firstName && !lastName) {
        initials = '';
    } else if (!lastName) {
        initials = firstName.charAt(0);
    } else {
        initials = firstName.charAt(0) + lastName.charAt(0);
    }

    return initials.toUpperCase();
};

export const formatCents = (cents: number): string => {
    return cents === 0 ? '$0' : '$' + (cents / 100).toFixed(2).toString();
};

export const orgPrefixedName = (
    obj: { name: string; organization: { name: string } },
    showOrgName: boolean,
): string => (showOrgName ? `${obj.organization.name} // ${obj.name}` : obj.name);

export const schedulingConstraintsStr = ({
    minVisitsPerWeek,
    maxVisitsPerWeek,
    startDate,
    endDate,
    duration,
    unitTime,
}: {
    minVisitsPerWeek?: number | null;
    maxVisitsPerWeek?: number | null;
    startDate?: Moment | null;
    endDate?: Moment | null;
    duration?: number | null;
    unitTime?: number | null;
}) => {
    if (
        !minVisitsPerWeek &&
        !maxVisitsPerWeek &&
        !startDate &&
        !endDate &&
        !duration &&
        !unitTime
    ) {
        return 'No constraints';
    }

    const minVisitsPerWeekStr = minVisitsPerWeek ? `at least ${minVisitsPerWeek}` : '';
    const maxVisitsPerWeekStr = maxVisitsPerWeek ? `at most ${maxVisitsPerWeek}` : '';
    const startDateStr = startDate ? `starting ${startDate.format('MM/DD/YYYY')}` : '';
    const endDateStr = endDate ? `ending ${endDate.format('MM/DD/YYYY')}` : '';
    return `${minVisitsPerWeekStr}${
        minVisitsPerWeekStr && maxVisitsPerWeek ? ' and ' : ''
    }${maxVisitsPerWeekStr}${
        unitTime ? ' time(s) every ' + unitTime.toString() + ' week(s) ' : ''
    }${duration ? `for ${duration} weeks ` : ''}${startDateStr}${
        startDateStr && endDateStr ? ' and ' : ''
    }${endDateStr}`.replace(/^\w/, (match) => match.toUpperCase());
};

export const roundNumber = (num: number, maxDecimalPlaces: number): number => {
    return Math.round(num * 10 ** maxDecimalPlaces) / 10 ** maxDecimalPlaces;
};
